Vue.component('unlockQueue', {
  template: templates.unlockQueue,
  data() {
    return {
      model: {
        unlocks: {},
        packs: {},
        hasResults: false
      }
    }
  },
  mounted() {
    const c = this;
    
    c.get();
    c.getPacks();
  },
  methods: {
    get() {
      const c = this;
      let data = {};
      let getUsers = false;

      unlockQueueService.getQueue()
        .then(function (response) {
          c.model.hasResults = true;
          for (let d of response.data) {
            d.disabled = false;
            data[`${d.id}`] = d;

            if (d.twitchDisplayName == null) {
              getUsers = true;
            }
          }

          if (getUsers) {

            twitchAPI.getUsersById(data, function(userData) {

              for (let d of userData) {
                for (let i in data) {
                  if (data[`${i}`].twitchId == d.id) {
                    data[`${i}`].twitchDisplayName = d.display_name;
                    data[`${i}`].open = false;
                  }
                }
              }
    
              c.model.unlocks = data;

            });

          } else {
            c.model.unlocks = data;
          }
          
          setTimeout(function() {
            c.get();
          }, 10000);

        })
        .catch(function (error) {
          c.model.hasResults = false;
          setTimeout(function() {
            c.get();
          }, 10000);
        });
    },
    getPacks() {
      const c = this;
      let data = {};

      packService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.packs = data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    open(id) {
      const c = this;
      
      c.save(id);
    },
    save(id) {
      const c = this;

      c.model.unlocks[`${id}`].disabled = true;

      unlockQueueService.save({id: id})
        .then(function (response) {
          c.model.unlocks[`${id}`].active = false;
        })
        .catch(function (error) {
          //console.log(error);
        });
    }, 
    cancel(id) {
      const c = this;

      var result = confirm("Are you sure you want to remove this pack from the queue?");
      if (result == true) {
        unlockQueueService.cancel({id: id})
          .then(function (response) {
            c.model.unlocks[`${id}`].active = false;
          })
          .catch(function (error) {
            //console.log(error);
          });
      }
    }
  }
});